import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@aspnet/signalr';

export class ConnectionManager {
  private _connection: HubConnection | undefined;

  public createConnection(roomId: string) {
    if (this._connection) return;

    const url = process.env.VUE_APP_NEGOTIATE_URL;
    this._connection = new HubConnectionBuilder()
      .withUrl(url + '/api?roomId=' + roomId, {})
      .configureLogging(LogLevel.Information)
      .build();
  }

  public connect() {
    return this._connection?.start();
  }

  public disconnect() {
    return this._connection?.stop();
  }

  // eslint-disable-next-line
  public send(methodName: string, ...args: any[]) {
    this._connection?.send(methodName, ...args);
  }

  public isConnected() {
    return this._connection && this._connection.state === HubConnectionState.Connected;
  }

  // eslint-disable-next-line
  public on(message: string, callback: (...args: any[]) => void, self: object) {
    this._connection?.on(message, (...args) => callback.apply(self, args));
  }
  public off(message: string) {
    this._connection?.off(message);
  }
}

export default new ConnectionManager();
